module.exports = __webpack_public_path__ + "static/portfolio-image-12-3b2ed2a536dfebe7a231cc172c6ff4d7.jpg";